class CustomSwatchSection extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

        var swiper = new Swiper(".custom-swatch-card-slider-"+ this.getAttribute("data-sectionid"), {
            slidesPerView: 3,
            spaceBetween: 40,
            pagination: {
            el: '.swiper-pagination',
            clickable: true,
            },
            navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            },
            breakpoints: {
            280: {
                slidesPerView: 1,
                spaceBetween: 15,
            },
            750: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
            },
        });

      $(this).css({"opacity":"1"});

    }; 

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}

customElements.define("custom-swatch-section", CustomSwatchSection);
